<!-- eslint-disable no-unused-vars -->
<script setup>
import DefaultErrorFallback from '@/error/default-error-fallback.vue'
import { ref, computed, onErrorCaptured, onMounted } from 'vue'

const hasError = ref(false)

const props = defineProps({
  fallBack: {
    type: Object,
    default: null,
  },
  params: {
    type: Object,
    default: () => ({}),
  },
  onError: {
    type: Function,
    default: () => {},
  },
  stopPropagation: {
    type: Boolean,
    default: false,
  },
})

const fallBackProps = computed(() => ({
  params: props.params,
}))

onErrorCaptured((error, instance, info) => {
  hasError.value = true
  props.onError(error, instance, info)

  const component = instance?.$options?.name
  this.$logger.noticeError(error, { component })

  if (props.stopPropagation) {
    return false
  }
})
</script>

<template>
  <div>
    <slot v-if="!hasError" />
    <component
      :is="props.fallBack || DefaultErrorFallback"
      v-else
      v-bind="fallBackProps"
    />
  </div>
</template>
